<script lang="ts">

	import { Modal, ModalBody, ModalHeader, Form, FormGroup, Label, Col, Row } from "sveltestrap";
	import StateInput from "./StateInput.svelte";

	let open = false;

	export let section = null;

	$: open = !!section;

	function toggle(): void {
		open = !open;
	}

</script>

<Modal isOpen={open} {toggle} size="lg" on:close>
	<ModalHeader {toggle}>Editar Pregunta</ModalHeader>
	<ModalBody>
		<Form id="info">
			<Row>
				<Col xs="12" sm="6">
					<FormGroup>
						<Label for="tittle">Título de la Sección</Label>
						<StateInput type="text" store={section.name} />
					</FormGroup>
					<FormGroup>
						<StateInput type="checkbox" label="Respuesta obligada" store={section.required} />
					</FormGroup>
					<!-- <FormGroup>
						<Label for="tittle">Ancho de la sección</Label>
						<WidthSelect value={section.width} />
					</FormGroup>-->
				</Col>
			</Row>
		</Form>
	</ModalBody>
</Modal>
